module.exports = {
   "API_URL" : "https://api-v2.yanuangga.com/api/beta/",
   //"API_URL" : "http://localhost:3000/api/beta/",
   "secretKey": "1234567x"
}